import { IPageSettings } from "../page-settings"

export const gameSettings: IPageSettings = {
  headerClass: "gradient",
}
